<template>
  <div class="h-full">
    <vue-headful :title="appDocTitle"/>
    <div id="app" class="container h-full">
      <router-view></router-view>
    </div>
    <toast-notification v-on:close="removeToast" v-if="showToast" :message="toastPayload.message" :type="toastPayload.type" :timeout="toastPayload.timeout" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import vueHeadful from 'vue-headful';

  import '@/theme/style.scss';
  import ToastNotification from '@/component/ToastNotification';
  import { SHOW_NOTIFICATION } from '@/store/actions/app.actions';
  import { routeBaseTitle } from '@/router/utils';

  export default {
    name: 'App',

    components: {
      ToastNotification,
      vueHeadful
    },

    data: function() {
      return {
        showToast: false,
        toastPayload: {
          type: null,
          message: null,
          timeout: null,
        },
        routeBaseTitle: routeBaseTitle
      }
    },

    computed: {
      ...mapGetters(['pagesPending', 'appDocTitle'])
    },

    methods: {
      addToast: function(payload) {
        if (this.showToast) {
          return this.removeToast()
              .then(() => {
                this.toastPayload = payload;
                this.showToast = true;
              })
        }

        this.toastPayload = payload;
        this.showToast = true;
      },

      removeToast: function() {
        return new Promise((resolve) => {
          this.showToast = false;

          this.toastPayload = {
            type: null,
            message: null,
            timeout: null,
          };

          resolve(true);
        })
      }
    },

    created: function () {
      this.$store.subscribeAction(action => {
        if (action.type === SHOW_NOTIFICATION) {
          this.addToast(action.payload);
        }
      });
    }
  };
</script>
